import React from 'react';
import { View, StyleSheet, TouchableOpacity, Image } from 'react-native';
import theme from '../../constants/theme.style.js';
import { MessageDetailHeader } from '../../components/messageDetailHeader/MessageDetailHeader';
import { MessageDetailText } from '../../components/messageDetailText/MessageDetailText';
import { MessageDetailAttachment } from '../../components/messageDetailAttachment/MessageDetailAttachment';

const backButtonIcon = require('../../assets/icons/navigation/arrowBack.png');

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: 40,
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  body: {
    flex: 1,
    backgroundColor: theme.WHITE_COLOR,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    paddingTop: 10,
  },
  backButton: {
    width: 60,
    height: 40,
    marginTop: 50,
    marginLeft: 30,
    marginBottom: 10,
    padding: 0,
  },
  backButtonIcon: {
    width: 25,
    height: 24,
  },
});

export default class InboxDetail extends React.Component {
  static navigationOptions = {
    title: 'Inbox Detail',
    headerShown: false,
  };

  constructor(props) {
    super(props);

    const { message, navigation } = this.props;
    const id = navigation.getParam('id');
    const isInbox = navigation.getParam('isInbox');
    this.state = {
      message: message(id),
      isInbox,
    };
  }

  render() {
    const { message, isInbox } = this.state;
    const { navigation } = this.props;
    const attachments = message.media.length > 0 ? message.media : null;

    return (
      <View style={styles.container}>
        <TouchableOpacity
          style={styles.backButton}
          testID="backbutton"
          onPress={() => navigation.navigate('Inbox')}
        >
          <Image style={styles.backButtonIcon} source={backButtonIcon} />
        </TouchableOpacity>
        <View style={styles.body}>
          <MessageDetailHeader
            deliverAt={message.deliverAt}
            sender={message.sender}
            recipient={message.recipient}
            location={message.location}
            isInbox={isInbox}
          />
          <MessageDetailText text={message.text} />
          {attachments && <MessageDetailAttachment images={attachments} />}
        </View>
      </View>
    );
  }
}
